export default "/images/framework/LoginDesign.abb9821e.svg?abb9821e";